import { LicenseAvailabilityColor } from "~/shared/lib/licenseAvailability";

export const LICENSE_ORGANIZATION_TOTALS_ROW_ID = "licenseOrganizationTotals";

export interface ILicenseOrganizationRow {
  id: string;
  instanceId: number | null;
  positionCode: string;
  positionName: string;
  availabilityColor: LicenseAvailabilityColor;
  totalQuantity: number;
  assignedQuantity: number;
  usedQuantity: number;
  frozenQuantity: number;
  freeQuantity: number;
  expiredQuantity: number;
}

export type ILicenseOrganizationUrlParams = {
  dealerId?: string;
  organizationId?: string;
  organizationName?: string;
  licenseType?: string;
  page?: number | string;
  count?: number | string;
  sortField?: string;
  sortType?: string;
};
